import { render, staticRenderFns } from "./card.vue?vue&type=template&id=308c8115&scoped=true"
import script from "./card.vue?vue&type=script&lang=js"
export * from "./card.vue?vue&type=script&lang=js"
import style0 from "./card.vue?vue&type=style&index=0&id=308c8115&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308c8115",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('308c8115')) {
      api.createRecord('308c8115', component.options)
    } else {
      api.reload('308c8115', component.options)
    }
    module.hot.accept("./card.vue?vue&type=template&id=308c8115&scoped=true", function () {
      api.rerender('308c8115', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/card/card.vue"
export default component.exports